require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/es7.symbol.observable.js
// module id = 238
// module chunks = 1